import { useQuery } from "@tanstack/react-query";
import panelApi from "@/lib/panelApi";

export const useBaseSalaries = () =>
  useQuery({ queryKey: ["panel-base-salaries"], queryFn: async () => (await panelApi.get("/panel/base-salaries")).data?.values || {} });

// Base usada para o salário por base: a selecionada no filtro; em "Todas", a base de pagamento ou a única base vinculada.
export const salaryBaseOf = (uid, selected, payBases, collabById) => {
  if (selected) return selected;
  if (payBases?.[uid]) return payBases[uid];
  const ids = collabById?.[uid]?.base_ids || [];
  return ids.length === 1 ? ids[0] : null;
};
